import { Route } from "react-router-dom";
import PageWrapper from "../Controller/LayoutController/PageWrapper";
import AgricultureAppRoutes from "./AgricultureAppRoutes";
import { RouteType } from "./Routesconfig";
import InfraStructureAppRoutes from "./InfraStructureAppRoutes";
import WasteManagementAppRoutes from "./WasteManagementAppRoutes";
import RetailAppRoutes from "./RetailAppRoutes";
import React from "react";

const generateRoute = (routes: RouteType[]) => {
  return routes.map((route, index) =>
    route.index ? (
      <Route
        index
        path={route.path}
        element={
          <PageWrapper state={route.state}>
            {React.isValidElement(route.element)
              ? route.element
              : React.createElement(route.element as React.ComponentType<any>)}
          </PageWrapper>
        }
        key={index}
      />
    ) : (
      <Route
        path={route.path}
        element={
          <PageWrapper state={route.child ? undefined : route.state}>
            {React.isValidElement(route.element)
              ? route.element
              : React.createElement(route.element as React.ComponentType<any>)}
          </PageWrapper>
        }
        key={index}
      >
        {route.child && generateRoute(route.child)}
      </Route>
    )
  );
};

/* To make top navigation visual with role */

var roleDatas: RouteType[] = [
  ...AgricultureAppRoutes,
  ...InfraStructureAppRoutes,
  ...WasteManagementAppRoutes,
  ...RetailAppRoutes,
].filter((x) => x.role === "SUPER_ADMIN");

export const routes = generateRoute(roleDatas);
